import { cn } from 'lib/helpers/utility';

import Typography from 'components/shared/Typography/Typography';

const InfoItem = ({ label, value, size = 'small', color, className }) => {
  return (
    <Typography
      variant="p"
      size={size}
      weight="medium"
      color={color}
      className={cn('whitespace-normal', className)}>
      {label && `${label}: `} {value}
    </Typography>
  );
};

export default InfoItem;
